import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MemberLoyaltyStatus, MemberLoyaltyStatusQuery } from '@fgb/core';

interface MembershipProgressViewModel {
  tierName: string;
  nextTierName: string;
  pointsToNextTier: number;
  progressPercent: number;
}

@Component({
  selector: 'fgb-membership-progress',
  templateUrl: './membership-progress.component.html',
  styleUrls: ['./membership-progress.component.scss'],
})
export class MembershipProgressComponent implements OnInit {
  viewModel$: Observable<MembershipProgressViewModel>;

  constructor(private memberLoyaltyStatusQuery: MemberLoyaltyStatusQuery) {}

  ngOnInit() {
    this.viewModel$ = this.memberLoyaltyStatusQuery.select().pipe(map((status) => this.toViewModel(status)));
  }

  private toViewModel(status: MemberLoyaltyStatus): MembershipProgressViewModel {
    const hasNextTier = !!status?.NextTierDescription && status.NextTierLoyaltyPoints > 0;
    const pointsAchieved = hasNextTier ? status.NextTierLoyaltyPoints - status.PointsRequiredToRise : 0;
    const progressPercent = hasNextTier ? Math.min(100, Math.max(0, (pointsAchieved / status.NextTierLoyaltyPoints) * 100)) : 100;

    return {
      tierName: status?.TierDescription,
      nextTierName: hasNextTier ? status.NextTierDescription : '',
      pointsToNextTier: hasNextTier ? status.PointsRequiredToRise : 0,
      progressPercent,
    };
  }
}
